import MemberProgressBarLegendTooltip from "@/product/reports/MemberProgressBarLegendTooltip"
import { EventAttendanceProgressBarFragment$key } from "@/product/reports/page/event-attendance/__generated__/EventAttendanceProgressBarFragment.graphql"
import Relay from "@/relay/relayUtils"
import { DiscoText, DiscoTextSkeleton, DiscoTooltip } from "@disco-ui"
import DiscoProgressBar from "@disco-ui/progress/DiscoProgressBar"
import { Skeleton } from "@material-ui/lab"
import { isPast } from "date-fns"
import { graphql, useFragment } from "react-relay"

interface EventAttendanceProgressBarProps {
  memberKey: EventAttendanceProgressBarFragment$key
}

const EventAttendanceProgressBar: React.FC<EventAttendanceProgressBarProps> = ({
  memberKey,
}) => {
  const membership = useFragment<EventAttendanceProgressBarFragment$key>(
    graphql`
      fragment EventAttendanceProgressBarFragment on ProductMembership {
        id
        occurrenceAttendances {
          edges {
            node {
              id
              occurrenceId
            }
          }
        }
        eventOccurrences(filterEventsToMembershipPeriod: true) {
          totalCount
          edges {
            node {
              id
              datetimeRange
            }
          }
        }
      }
    `,
    memberKey
  )

  const total = membership.eventOccurrences!.totalCount
  const completed = new Set(
    Relay.connectionToArray(membership.occurrenceAttendances).map((oa) => oa.occurrenceId)
  ).size
  const ended = Relay.connectionToArray(membership.eventOccurrences).filter((event) =>
    isPast(new Date(event.datetimeRange[0]))
  )

  const progress = total ? (completed / total) * 100 : 0
  const bufferProgress = total ? (ended.length / total) * 100 : 0

  return (
    <div>
      <DiscoText
        data-testid={"EventAttendanceProgressBar.ratio"}
        variant={"body-sm"}
        color={"text.secondary"}
      >{`${completed}/${total}`}</DiscoText>

      <DiscoTooltip
        content={
          <MemberProgressBarLegendTooltip
            progress={progress}
            bufferProgress={bufferProgress}
            variant={"event"}
            total={total}
          />
        }
      >
        <div>
          <DiscoProgressBar
            percentage={progress}
            bufferPercentage={bufferProgress}
            width={"72px"}
          />
        </div>
      </DiscoTooltip>
    </div>
  )
}

export const EventAttendanceProgressBarSkeleton: React.FC = () => {
  return (
    <div>
      <DiscoTextSkeleton variant={"body-sm"} width={30} />
      <Skeleton variant={"rect"} width={72} height={8} />
    </div>
  )
}

export default Relay.withSkeleton<EventAttendanceProgressBarProps>({
  component: EventAttendanceProgressBar,
  skeleton: EventAttendanceProgressBarSkeleton,
})
